import { colors, font, spacing } from '@chegg-ui/theme'
import { DEMO_GRAMMAR_SUGGESTION_TEXT_ID } from '@src/utils/dataTestIds'
import * as React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  height: ${spacing.px24};
`

const Text = styled.span`
  font-size: ${font.size.px12};
  color: ${colors.grey};
`

const Highlighted = styled.span`
  color: ${colors.dark};
`

export const DemoSuggestionText: React.FC = () => (
  <Container data-test={DEMO_GRAMMAR_SUGGESTION_TEXT_ID}>
    <Text>
      <Highlighted>5 free </Highlighted>
      grammatical suggestions
    </Text>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/Cards/DemoSuggestionText.tsx